import React, { useRef, useState } from "react";
import { FaRegWindowClose } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import { useForm } from "react-hook-form";
import "./AddChassisModal.scss";

const AddChassisModal = ({ isOpen, setIsOpen, paiement, setPaiement, handleInput }) => {
  const modalRef = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const { register, handleSubmit, reset, formState: { errors } } = useForm();

  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      setIsOpen(false);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (value.length <= 17) {
      setInputValue(value.toUpperCase());
    }
  };

  const addChassis = (data) => {
    const newChassis = data.numeroChassis?.trim().toUpperCase();
    if (newChassis) {
      if (handleInput) {
        const syntheticEvent = {
          target: {
            name: "numeroChassis",
            value: [...(paiement.infovehicule.numeroChassis || []), newChassis]
          }
        };
        handleInput(syntheticEvent);
      } else {
        setPaiement(prev => ({
          ...prev,
          infovehicule: {
            ...prev.infovehicule,
            numeroChassis: [...(prev.infovehicule.numeroChassis || []), newChassis]
          }
        }));
      }
      reset();
      setInputValue("");
    }
  };

  const removeChassis = (indexToRemove) => {
    if (handleInput) {
      const updatedChassis = paiement.infovehicule.numeroChassis.filter((_, index) => index !== indexToRemove);
      const syntheticEvent = {
        target: {
          name: "numeroChassis",
          value: updatedChassis
        }
      };
      handleInput(syntheticEvent);
    } else {
      setPaiement(prev => ({
        ...prev,
        infovehicule: {
          ...prev.infovehicule,
          numeroChassis: prev.infovehicule.numeroChassis.filter((_, index) => index !== indexToRemove)
        }
      }));
    }
  };

  return (
    <AnimatePresence>
      {isOpen ? (
        <div className="modal-component" onClick={closeModal} ref={modalRef}>
          <motion.div 
            initial={{ opacity: 0, top: "30%" }} 
            animate={{ opacity: 1, top: "50%" }} 
            transition={{ duration: 0.2 }} 
            exit={{ opacity: 0, top: "10%" }}
            className="modal"
          >
            <div className="close" onClick={() => setIsOpen(false)}>
              <FaRegWindowClose id="close-icon" />
            </div>
            <h4>Ajouter un chassis</h4>
            <form onSubmit={handleSubmit(addChassis)}>
              <div className="input-container">
                <label>Numéro de chassis</label>
                <div className="input-with-counter">
                  <input 
                    type="text"
                    value={inputValue}
                    style={{ textTransform: "uppercase" }}
                    {...register("numeroChassis", {
                      required: "Le numéro de chassis est obligatoire",
                      minLength: {
                        value: 2,
                        message: "Minimum 2 caractères requis"
                      },
                      maxLength: {
                        value: 17,
                        message: "Maximum 17 caractères autorisés"
                      }
                    })}
                    onChange={handleInputChange}
                    maxLength={17}
                  />
                  <span className="char-counter">
                    {inputValue.length}/17
                  </span>
                </div>
                {errors.infovehicule?.numeroChassis && (
                  <span className="error-msg">{errors.infovehicule.numeroChassis.message}</span>
                )}
              </div>
              <button type="submit">Ajouter</button>
            </form>

            {paiement.infovehicule.numeroChassis?.length > 0 && (
              <div className="modal-chassis-list">
                <div className="chassis-header">
                  <h5>Chassis enregistrés:</h5>
                  <p className="chassis-count">{paiement.infovehicule.numeroChassis.length}</p>
                </div>
                <div className="chassis-items-container">
                  {paiement.infovehicule.numeroChassis.map((chassis, index) => (
                    <div key={index} className="chassis-item">
                      <span>{chassis}</span>
                       <button 
                        type="button" 
                        onClick={() => removeChassis(index)}
                        className="remove-chassis"
                        aria-label={`Supprimer le chassis ${chassis}`}
                      >
                        ×
                       </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </motion.div>
        </div>
      ) : null}
    </AnimatePresence>
  );
};

export default AddChassisModal;